import { toDollars } from "../../helpers/currencies";
import APCalculation from "./APCalculation";

const APCalculationInput = ({
  name,
  value,
  currency,
  percentage,
}: {
  name: string;
  value: number;
  currency?: boolean;
  percentage?: boolean;
}) => {
  let renderedValue = currency ? toDollars(value, 2) : `${value}`;

  if (percentage) {
    renderedValue = `${renderedValue}%`;
  }

  return <APCalculation name={name} value={renderedValue} />;
};

export default APCalculationInput;
